export default __webpack_public_path__ + "static/media/creator3.6860c1bc.jpeg";